export class Moving {
  constructor(rocket) {
    this.rocket = rocket
    this.isMovingDirectionRigth = undefined
    this.elapsed = 0
    this.lastSin = undefined
    this.firstDirection = null
    this.distance = 120
  }
  setTickerMoving = (ticker) => {
    if (ticker) {
      this.ticker = ticker
    }
  }
  setIsMovingDirectionRight = (md) => (this.isMovingDirectionRight = md)
  getIsMovingDirectionRight = () => this.isMovingDirectionRight

  resetRocketMovingVariables = () => {
    this.elapsed = 0
    this.firstDirection = null
    this.isMovingDirectionRight = undefined
    this.lastSin = undefined
  }

  moveRight = () => {
    this.ticker.remove(this.moveRockeRight)
    this.ticker.add(this.moveRockeRight)
    this.isMovingDirectionRight = true
  }
  moveRockeRight = (delta) => {
    this.elapsed += delta
    let sin = Math.sin(this.elapsed / 20)
    if (this.firstDirection) {
      this.rocket.x = 158 + sin * this.distance
      this.rocket.rotation = sin > 0 ? (-sin + 1) / 2 : (sin + 1) / 2
    } else {
      this.rocket.x = 158 + sin * this.distance
      this.rocket.rotation = sin > 0 ? (-sin + 1) / 4 : (sin + 1) / 4
    }

    if (this.lastSin > Math.sin(this.elapsed / 20)) {
      this.ticker.remove(this.moveRockeRight)
      this.firstDirection = true
      return
    }

    this.lastSin = sin
  }

  moveLeft = () => {
    this.ticker.remove(this.moveRocketLeft)
    this.ticker.add(this.moveRocketLeft)
    this.isMovingDirectionRight = false
    if (!this.firstDirection) {
      this.elapsed = 63.069299999999934
    }
  }

  moveRocketLeft = (delta) => {
    this.elapsed += delta
    let sin = Math.sin(this.elapsed / 20)
    this.rocket.rotation = sin > 0 ? (sin - 1) / 2 : (-sin - 1) / 2
    this.rocket.x = 158 + sin * this.distance

    if (this.firstDirection) {
      this.rocket.rotation = sin > 0 ? (sin - 1) / 2 : (-sin - 1) / 2
    } else {
      this.rocket.rotation = sin > 0 ? (sin - 1) / 4 : (-sin - 1) / 4
    }
    if (this.lastSin < Math.sin(this.elapsed / 20)) {
      this.ticker.remove(this.moveRocketLeft)
      this.firstDirection = true
      return
    }
    this.lastSin = sin
  }

  moveNow = (randX) => {
    if (this.firstDirection === null) {
      if (randX < 142) {
        this.moveRight()
      } else {
        this.moveLeft()
      }
    }
    if (randX < 142) {
      if (!this.isMovingDirectionRight) {
        this.moveRight()
      }
    } else {
      if (this.isMovingDirectionRight) {
        this.moveLeft()
      }
    }
  }

  moveToAsteroidNow = () =>
    this.isMovingDirectionRight ? this.moveLeft() : this.moveRight()
}
